import Filter from './Filter';

export {
    Filter
};


// WEBPACK FOOTER //
// ./src/components/filter/index.js